import React from "react";
import RecruitLayout from "./recruitLayout";
import Recruit from "common/pages/common/-pages/recruit/recruit";
import Seo from "components/Seo";

const MorningRecruit = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="채용지원" />
            <RecruitLayout>
                <Recruit type="morning" />
            </RecruitLayout>
        </React.Fragment>
    );
};

export default MorningRecruit;
